import { combineReducers } from 'redux';
import {
  SET_COLUMN_BACKGROUND_COLOR,
  SET_COLUMN_PADDING
} from '../actions/action-names';

const backgroundColor = (state = '#ffffff', action) => {
  switch (action.type) {
    case SET_COLUMN_BACKGROUND_COLOR:
      return action.color;
    default:
      return state;
  }
};

const padding = (state = 0, action) => {
  switch (action.type) {
    case SET_COLUMN_PADDING:
      return action.padding;
    default:
      return state;
  }
};

export default combineReducers({
  backgroundColor,
  padding
});



// WEBPACK FOOTER //
// ./app/header-builder/reducers/column-options-reducers.js